import { Checkbox } from "@/components/ui/checkbox";
import { Attribute } from "../../models";
import { DataMapping } from "../step-2-choose-data/choose-data";

interface DataTreeProps {
  dataMappings?: DataMapping[];
  selected: Attribute[];
}

export const DataTree = (props: DataTreeProps) => {
  const isSelected = (selected: Attribute[], id: string, parentId?: string) => {
    if (parentId) {
      const parent = selected.find((s) => s.key == parentId);
      if (parent) {
        //@ts-ignore
        return parent.attributes.indexOf(id) > -1;
      }
      return false;
    } else {
      const item = selected.find((s) => s.key == id);
      return !!item;
    }
  };

  return (
    <>
      {props.dataMappings
        ?.filter((dataMapping) =>
          isSelected(props.selected, dataMapping.id, undefined)
        )
        .map((dataMapping) => (
          <div key={dataMapping.id} className="flex flex-col ml-6">
            <div>
              <label className="flex items-center gap-2 mr-2 py-1">
                <Checkbox
                  checked={isSelected(
                    props.selected,
                    dataMapping.id,
                    undefined
                  )}
                  disabled
                  className="text-muted-foreground"
                />
                <span className="text-sm">{dataMapping.name}</span>
              </label>
              <div className="flex flex-col ml-6">
                {dataMapping.children
                  ?.filter((child) =>
                    isSelected(props.selected, child.id, dataMapping.id)
                  )
                  .map((child) => (
                    <div key={child.id} className="flex items-center">
                      <label className="flex items-center gap-2 mr-2 py-1">
                        <Checkbox
                          checked={isSelected(
                            props.selected,
                            child.id,
                            dataMapping.id
                          )}
                          disabled
                          className="text-muted-foreground"
                        />
                        <span className="text-sm">{child.name}</span>
                      </label>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};
